/* eslint-disable import/prefer-default-export */
export const appointmentConstants = {
  GET_APPOINTMENT_DONE_REQUEST: 'GET_APPOINTMENT_DONE_REQUEST',
  GET_APPOINTMENT_DONE_SUCCESS: 'GET_APPOINTMENT_DONE_SUCCESS',
  GET_APPOINTMENT_DONE_FAILURE: 'GET_APPOINTMENT_DONE_FAILURE',

  GET_APPOINTMENT_REQUEST: 'GET_APPOINTMENT_REQUEST',
  GET_APPOINTMENT_SUCCESS: 'GET_APPOINTMENT_SUCCESS',
  GET_APPOINTMENT_FAILURE: 'GET_APPOINTMENT_FAILURE',

  SET_REGISTRANT_STATUS_REQUEST: 'SET_REGISTRANT_STATUS_REQUEST',
  SET_REGISTRANT_STATUS_SUCCESS: 'SET_REGISTRANT_STATUS_SUCCESS',
  SET_REGISTRANT_STATUS_FAILURE: 'SET_REGISTRANT_STATUS_FAILURE',

  DELETE_REGISTRANT_REQUEST: 'DELETE_REGISTRANT_REQUEST',
  DELETE_REGISTRANT_SUCCESS: 'DELETE_REGISTRANT_SUCCESS',
  DELETE_REGISTRANT_FAILURE: 'DELETE_REGISTRANT_FAILURE',

  DELETE_APPOINTMENTS_REQUEST: 'DELETE_APPOINTMENTS_REQUEST',
  DELETE_APPOINTMENTS_SUCCESS: 'DELETE_APPOINTMENTS_SUCCESS',
  DELETE_APPOINTMENTS_FAILURE: 'DELETE_APPOINTMENTS_FAILURE',

  CREATE_APPOINTMENT_REQUEST: 'CREATE_APPOINTMENT_REQUEST',
  CREATE_APPOINTMENT_SUCCESS: 'CREATE_APPOINTMENT_SUCCESS',
  CREATE_APPOINTMENT_FAILURE: 'CREATE_APPOINTMENT_FAILURE',
};
